// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/animate.css
// module id = llnD
// module chunks = 2